<template>
  <v-container class="pa-12">
    <v-card-title class="display-1 font-weight-bold pa-0 mb-8">
      <v-icon v-if="request.id && editMode" @click="editMode = !editMode">
        $arrowLeft
      </v-icon>
      {{ request.id ? request.name : 'Add Tour' }}
    </v-card-title>

    <!--  adding  location List -->
    <v-list-item-group
      v-if="request.id && !editMode"
      color="primary tour-list-boxes"
      class="mb-12"
    >
      <v-list-item :ripple="false" :inactive="true" color="#2f2727">
        <v-list-item-icon>
          <v-icon color="black">$marker</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">
            {{ request.location.lat }}, {{ request.location.lng }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item @click="editMode = true">
        <v-list-item-icon>
          <v-icon color="black">$editOutline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">
            Edit Site
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item :ripple="false" :inactive="true" color="#2f2727">
        <v-list-item-icon>
          <v-icon color="black">$questionOutline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">
            Have questions?
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list-item-group>

    <v-form v-show="!request.id || editMode" class="mb-12">
      <validation-provider name="name" rules="required" v-slot="{ errors }">
        <v-text-field
          type="text"
          name="name"
          label="Tour Name"
          v-model="request.name"
          :error-messages="errors"
        />
      </validation-provider>
      <validation-provider
        name="tour_type"
        rules="required"
        v-slot="{ errors }"
      >
        <v-select
          :menu-props="{ contentClass: 'notranslate' }"
          name="type_id"
          :items="types"
          item-text="name"
          :error-messages="errors"
          item-value="id"
          v-model="request.type_id"
          label="Type of Tour"
        />
      </validation-provider>
      <LocationField
        name="location"
        v-model="request.location"
        :pickLocationManually="true"
        :required="true"
      />
      <validation-provider name="project_ids" v-slot="{ errors }">
        <v-select
          class="notranslate"
          :menu-props="{ contentClass: 'notranslate' }"
          name="project_ids"
          :items="projects"
          item-text="name"
          :error-messages="errors"
          item-value="id"
          v-model="request.project_ids"
          label="Projects"
          multiple
        />
      </validation-provider>
    </v-form>
    <div v-if="request.species.length">
      <h3 class="mb-12 mb-md-5 headline font-weight-bold">
        Species
      </h3>
      <v-row>
        <v-col class="pa-0">
          <v-data-table
            :items="request.species"
            :headers="headers"
            class="primary-table border-radius-0 v-data-table-1 v-data-table-1--style3"
            v-bind="
              request.species.length > 5
                ? { itemsPerPage: 5 }
                : { hideDefaultFooter: true }
            "
          >
            <template v-slot:item.action="{ item }">
              <v-icon @click="showStat(item)" title="Show stat">
                $statistics
              </v-icon>
              <v-icon @click="remove(item)" title="Remove species">
                {{ item.isNew ? '$delete' : '$deleteAlert' }}
              </v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import TourRequest from '@request/TourRequest';

export default {
  name: 'CreateTours',
  components: {
    LocationField: () => import('@components/utilities/LocationField'),
  },
  props: {
    request: {
      type: TourRequest,
      required: true,
    },
    types: {
      type: Array,
      required: true,
    },
    projects: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      editMode: false,
      headers: [
        { text: 'Names', value: 'name' },
        { text: 'Family', value: 'family.name' },
        { text: 'Actions', value: 'action', width: '100px', sortable: false },
      ],
    };
  },
  methods: {
    showStat(species) {
      this.$emit('showStat', species);
    },
    async remove(species) {
      if (!species.isNew) {
        if (
          !(await $question(
            'Are you sure you want to remove this species from this tour?'
          ))
        ) {
          return;
        }
      }
      let ids = new Set(this.request.species_ids);
      ids.delete(species.id);
      this.request.species_ids = Array.from(ids);
      this.request.species = this.request.species.filter(
        (s) => s.id !== species.id
      );
    },
    exit(data = null) {
      this.request.reset();
      this.$emit('exit', data);
    },
  },
};
</script>

<style scoped></style>
